import { useTranslation } from 'react-i18next';
import { Button } from '@resideo/blueprint-oneportal';
import styles from './ResendConfirmModal.module.css';

export interface ResendConfirmModalProps {
  isResending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ResendConfirmModal({
  isResending,
  onConfirm,
  onCancel,
}: ResendConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.title}>{t('employees.resendInvite')}</p>
        <p className={styles.body}>{t('employees.resendInviteBody')}</p>
        <div className={styles.actions}>
          <Button variant="highlightTertiary" onClick={onCancel} disabled={isResending} style={{ fontWeight: 700 }}>
            {t('employees.resendInviteCancel')}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isResending} style={{ fontWeight: 700 }}>
            {isResending ? t('employees.resendInviteConfirming') : t('employees.resendInviteConfirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
